import { useState } from 'react';
import './ForgotPassword.css'; 
import api from '../Pages/Login and Sign UP/api.js'
let ForgotPassword=()=>{

    let [email, setemail]=useState('');
    let namechan=(e)=>{
        setemail(e.target.value);

    }
   
   
    

    let forgotpassrecoverfun= async()=>{
        // document.querySelector(".inputandbtncont").style.display = "none"
        // document.querySelector(".yourpass").innerHTML = "This page is under construction"
        if(!email){
            document.querySelector(".yourpass").innerHTML = "Please Enter EmailID";
            setTimeout(() => {
                 document.querySelector(".yourpass").innerHTML = "";
            }, 3000);
            return;
        }

        let forgotpassformdata = new FormData();
        forgotpassformdata.append('email', email); 
          
           try {
            const response = await api.post('/sendresetpassword.php', forgotpassformdata);
            document.querySelector(".yourpass").innerHTML = response.data.result == undefined ? "Password reset link successfully sent to your emailId Please check" : "Please Enter Valid EmailID";
            setTimeout(() => {
                    document.querySelector(".inputandbtncont").style.display = "block"
            }, 3000);

            setTimeout(() => {
                
                 document.querySelector(".yourpass").innerHTML = "";
            }, 3000);
           } catch (error) {
            console.log(error);
           } 
         

    }
    




     
    return(
        <div className='passforgotmaincone'>
            
            <div className='inputandbtncont'>
                <div style={{textAlign:"center"}} className='passrecinputcont'>
                    <h1 className='passheading'>Recover Password</h1>
                    <input onChange={namechan} className='passrecinput' type='email' placeholder='Email Id'/>
                </div>
                <div className='btncont'>     
                    <button className='recpassbtn' onClick={forgotpassrecoverfun}>Submit</button>
                </div>
            </div>
            <div className='showpasswordcont'>
                
                <h3 className='yourpass' style={{color : "green"}}></h3>
            </div>
            <p>Click here to<a href='LoginPage'> Login</a></p>
        </div>
    );
}
export default ForgotPassword;